export default __webpack_public_path__ + "static/media/ic-clock-out.ffff0284.svg";